import * as React from 'react';
import { Alert, FormGroup } from 'reactstrap';
import { Select } from '../../../components/ui/Select';
import { GetAllQuestions, IQuestion } from './utils';

interface IQuestionSelectProps {
  value: string
  onChange: (newValue: string | undefined, question: IQuestion | undefined) => void
  surveyAbbr?: string
  projectId?: string
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface IQuestionSelectState {
  questions: IQuestion[]
  isEmpty: boolean
}

export class QuestionSelect extends React.Component<IQuestionSelectProps, IQuestionSelectState> {
  state: IQuestionSelectState = {
    questions: [],
    isEmpty: false
  }

  private lastSurveyAbbr = ''
  private lastProjectId = ''

  componentWillMount() {
    this.loadQuestionsIfNeeded()
  }

  componentWillReceiveProps(props: IQuestionSelectProps) {
    this.loadQuestionsIfNeeded(props)
  }

  loadQuestionsIfNeeded(props = this.props) {
    const { value, surveyAbbr, projectId } = props

    if (typeof surveyAbbr === 'undefined' || typeof projectId === 'undefined') {
      this.setState({ questions: [] })

      if (value !== undefined) {
        this.props.onChange(undefined, undefined)
      }

    } else if (this.lastSurveyAbbr !== surveyAbbr || this.lastProjectId !== projectId) {
      this.setState({ questions: [] })

      if (surveyAbbr && projectId) {
        GetAllQuestions(surveyAbbr, projectId).then((res) => {
          const questions = res.values
          const isEmpty = questions.length <= 0

          this.setState({ questions, isEmpty })
        })
      }

      if (value !== undefined) {
        this.props.onChange(undefined, undefined)
      }
    }

    this.lastSurveyAbbr = surveyAbbr
    this.lastProjectId = projectId
  }

  onChange(newValue: string) {
    const { questions } = this.state;
    const { onChange } = this.props;
    const selectedQuestion = questions.find((q) => q.qid === newValue);

    onChange(newValue, selectedQuestion);
  }

  render() {
    const { value, required, readOnly, surveyAbbr } = this.props
    const { questions, isEmpty } = this.state
    const label = 'Question'

    return (
      <FormGroup>
        <label>Question</label>

        {isEmpty &&
          <Alert color="info">
            <i className="fas fa-fw fa-info-circle" />
            <span>&nbsp;No questions found; select another survey.</span>
          </Alert>
        }

        <Select<IQuestion, 'qid'>
          label={label}
          options={questions}
          value={value}
          readOnly={readOnly}
          required={required}
          loading={questions.length <= 0}
          valueKey="qid"
          labelKey="small_text"
          loadingText={!surveyAbbr ? 'Select a survey above' : undefined}
          onChange={(newValue) => this.onChange(newValue)} />
      </FormGroup>
    )
  }
}
